<template>
  <div>
    <v-text-field label="email" v-model="email"></v-text-field><br />
    <v-btn @click="startTest">Test</v-btn>
    <v-btn @click="startProd">Production</v-btn>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/firestore'

  //const functions = require('firebase-functions');
  //const admin = require('firebase-admin');

  export default {
    name: 'SiteChooser',
    components: {

    },
    computed: {
      ...mapState({
        env: (state) => state.env,
        serverLoc: (state) => state.serverLoc
      }),
    },
    data () {
      return {
        email: null,
      }
    },
    methods: {
      'init': async function(config) {
        console.log("Config FB: "+config.firebaseConfig)
        await firebase.initializeApp(config.firebaseConfig)

        // Send a login link
        let url = this.serverLoc+'/main'
        console.log("Continue URL: "+url)
        const actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for
          // this URL must be whitelisted in the Firebase Console.
          url: url,
          // This must be true for email link sign-in.
          handleCodeInApp: true,
          // FDL custom domain.
          // dynamicLinkDomain: config.webDomain
        };
        firebase.auth().sendSignInLinkToEmail('ddfleck@gmail.com', actionCodeSettings)

      },
      'startTest' : function () {
        console.log("Start test")
        // Init Firebase for test

        const c = require('../assets/configs/test-config.js')
        const config = c.default
        this.init(config)

        console.log("Test init'd  :"+JSON.stringify(config.firebaseConfig))

        this.$store.commit("setEnv", "test")
        this.$router.push({name:'MainPanel'})
      },
      'startProd' : function () {
        console.log("Start prod")
        // Init Firebase for prod
        const config = require('../assets/configs/prod-config.js')
        this.init(config)

        console.log("Prod init'd")
        this.$store.commit("setEnv", "prod")
        this.$router.push({name:'MainPanel'})
      }
    }
  }
</script>
